import { t } from "@lingui/macro";

export const DocsPage = () => (
  <main className="container py-24">
    <h1 className="text-4xl font-bold">{t`Documentation`}</h1>
  </main>
);
